<template>
  <div class="edit-image-card">
    <!-- 各パーツの編集 -->
    <div v-if="showTabContent || showTabStyle">
      <!-- 画像パーツ -->
      <image-edit
        :current="currentImage"
        :parts="parts.filter(part => part.type === 'Image')"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
        :partsContainerStyles="styles"
      />
      <!-- テキストボックスパーツ -->
      <boxed-text-edit
        :current="currentText"
        :parts="parts.filter(part => part.type === 'BoxedText')"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
        :partsContainerStyles="styles"
        :extTypeName="extTypeName"
        :class="{'exists-image': imagePart.attrs['data-key'] !== null}"
      />
    </div>
    <!-- カラム数、画像位置変更 -->
    <setting
      v-if="showTabSetting"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :parts="parts"
      :partsContainerType="partsContainerType"
      :partsContainerStyles="styles"
      @updateImageText="initComponent()"
    />
  </div>
</template>

<script>
import ImageEdit from '@/components/Content/Palette/EditPartDesign/Editor/Image'
import BoxedTextEdit from '@/components/Content/Palette/EditPartDesign/Editor/BoxedText'
import Setting from '@/components/Content/Palette/EditPartDesign/Editor/ImageText/ImageTextSetting'

export default {
  props: [
    'current',
    'styles',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'isMultiPart',
    'extTypeName',
  ],
  data () {
    return {
      currentImage: {
        tab: null,
        tableId: null,
      },
      currentText: {
        tab: null,
        tableId: null,
      },
    }
  },
  components: {
    ImageEdit,
    BoxedTextEdit,
    Setting,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    imageTableId () {
      let imageTableId
      if (this.isMultiPart.column || this.isMultiPart.row) {
        imageTableId = this.current.tableId
      } else {
        // マルチcolumnでもrowでもない場合：Imageパーツの、テーブルIDを取得
        const imagePart = this.parts.find(part => part.type === 'Image')
        imageTableId = imagePart['table_id']
      }
      return imageTableId
    },
    textTableId () {
      let textTableId
      if (this.isMultiPart.column || this.isMultiPart.row) {
        textTableId = this.current.tableId
      } else {
        // マルチcolumnでもrowでもない場合：Textのパーツの、テーブルIDを取得
        const textPart = this.parts.find(part => part.type === 'Text' || part.type === 'BoxedText')
        textTableId = textPart['table_id']
      }
      return textTableId
    },
    imagePart () {
      if (!this.parts) return
      return this.parts.find(part => part.type === 'Image')
    },
  },
  methods: {
    initComponent () {
      this.currentImage = { tab: this.current.tab, tableId: this.imageTableId }
      this.currentText = { tab: this.current.tab, tableId: this.textTableId }
    }
  },
  mounted () {
    this.initComponent()
  },
  watch: {
    isMultiPart: {
      deep: true,
      handler: function () {
        this.initComponent()
      }
    },
  },
}
</script>

<style lang="scss">
.edit-image-card {
  .boxed-text-editor {
    &.exists-image {
      .edit-style-select-color {
        .window {
          // テキストスタイルの文字色カラーピッカー 画像設定済みの場合 上方向に表示
          top: -275px;
        }
      }
    }
    .boxed-text-container-style {
      .edit-style-select-color {
        .window {
          // アウトラインの文字色カラーピッカー 上方向に表示
          top: -275px;
        }
      }
      .edit-style-border {
        .window {
          // アウトラインの罫線色カラーピッカー 上方向に表示
          top: -275px;
        }
      }
    }
  }
}
</style>
